export default function addFigure(doc, img, x, y, description, elementSize) {
    doc.setLineWidth(1);
    doc.setFontSize(10);
    doc.line(x, y - 6, x, y - 1);
    doc.text(description, x + 2, y - 2);
    doc.addImage(img, "jpg", x, y, elementSize.width, elementSize.height, undefined, "FAST");
}
